// 导入所有 dev 模块的国际化文件
import { messages as serviceRegisterMessages } from '@/lang/dev/serviceRegisterLang.js'
import { messages as sysDocumentMessages } from '@/lang/dev/sysDocumentLang.js'
import { messages as transactionLogMessages } from '@/lang/dev/transactionLogLang.js'
import { messages as serviceImplMessages } from '@/lang/dev/serviceImplLang.js'
import { messages as serviceManageMessages } from '@/lang/dev/serviceManageLang.js'
import { messages as serviceProvideMessages } from '@/lang/dev/serviceProvideLang.js'
import { messages as serviceBindingMessages } from '@/lang/dev/serviceBindingLang.js'
import { messages as menuManageMessages } from '@/lang/dev/menuManageLang.js'
import { messages as reportCustomComponentFooterMessages } from '@/lang/dev/reportCustomComponentFooterLang.js'
import { messages as reportCustomComponentMessages } from '@/lang/dev/reportCustomComponentLang.js'
import { messages as reportCustomComponentRelMessages } from '@/lang/dev/reportCustomComponentRelLang.js'
import { messages as reportCustomGroupMessages } from '@/lang/dev/reportCustomGroupLang.js'
import { messages as reportCustomMessages } from '@/lang/dev/reportCustomLang.js'
import { messages as serviceMessages } from '@/lang/dev/serviceLang.js'
import { messages as viewMenuGroupInfoMessages } from '@/lang/dev/viewMenuGroupInfoLang.js'
import { messages as mappingDomainMessages } from '@/lang/dev/mappingDomainLang.js'
import { messages as mappingMessages } from '@/lang/dev/mappingLang.js'
import { messages as menuCatalogMessages } from '@/lang/dev/menuCatalogLang.js'
import { messages as menuGroupCatalogMessages } from '@/lang/dev/menuGroupCatalogLang.js'
import { messages as menuGroupMessages } from '@/lang/dev/menuGroupLang.js'
import { messages as businessDatabusMessages } from '@/lang/dev/businessDatabusLang.js'
import { messages as businessTableHisMessages } from '@/lang/dev/businessTableHisLang.js'
import { messages as cacheManageMessages } from '@/lang/dev/cacheManageLang.js'
import { messages as chooseMenuGroupMessages } from '@/lang/dev/chooseMenuGroupLang.js'
import { messages as componentConditionMessages } from '@/lang/dev/componentConditionLang.js'
import { messages as configMenuMessages } from '@/lang/dev/configMenuLang.js'
import { messages as demoMessages } from '@/lang/dev/demoLang.js'
import { messages as dictMessages } from '@/lang/dev/dictLang.js'
import { messages as initializeCommunityManageMessages } from '@/lang/dev/initializeCommunityManageLang.js'
import { messages as jobMessages } from '@/lang/dev/jobLang.js'
import { messages as addMenuGroupMessages } from '@/lang/dev/addMenuGroupLang.js'
import { messages as addMenuViewMessages } from '@/lang/dev/addMenuViewLang.js'
import { messages as addPrivilegeViewMessages } from '@/lang/dev/addPrivilegeViewLang.js'
import { messages as appMessages } from '@/lang/dev/appLang.js'
import { messages as attrSpecMessages } from '@/lang/dev/attrSpecLang.js'
import { messages as attrValueMessages } from '@/lang/dev/attrValueLang.js'
import { messages as basePrivilegeMessages } from '@/lang/dev/basePrivilegeLang.js'
import { messages as privilegeMessages } from '@/lang/dev/privilegeLang.js'
import { messages as addRouteMessages } from '@/lang/dev/addRouteLang.js'
import { messages as menuMessages } from '@/lang/dev/menuLang.js'   

// 合并所有国际化消息
export const messages = {
    en: {
        ...serviceRegisterMessages.en,
        ...sysDocumentMessages.en,
        ...transactionLogMessages.en,
        ...serviceImplMessages.en,
        ...serviceManageMessages.en,
        ...serviceProvideMessages.en,
        ...serviceBindingMessages.en,
        ...menuManageMessages.en,
        ...reportCustomComponentFooterMessages.en,
        ...reportCustomComponentMessages.en,
        ...reportCustomComponentRelMessages.en,
        ...reportCustomGroupMessages.en,
        ...reportCustomMessages.en,
        ...serviceMessages.en,
        ...viewMenuGroupInfoMessages.en,
        ...mappingDomainMessages.en,
        ...mappingMessages.en,
        ...menuCatalogMessages.en,
        ...menuGroupCatalogMessages.en,
        ...menuGroupMessages.en,
        ...businessDatabusMessages.en,
        ...businessTableHisMessages.en,
        ...cacheManageMessages.en,
        ...chooseMenuGroupMessages.en,
        ...componentConditionMessages.en,
        ...configMenuMessages.en,
        ...demoMessages.en,
        ...dictMessages.en,
        ...initializeCommunityManageMessages.en,
        ...jobMessages.en,
        ...addMenuGroupMessages.en,
        ...addMenuViewMessages.en,
        ...addPrivilegeViewMessages.en,
        ...appMessages.en,
        ...attrSpecMessages.en,
        ...attrValueMessages.en,
        ...basePrivilegeMessages.en,
        ...privilegeMessages.en,
        ...addRouteMessages.en,
        ...menuMessages.en
    },
    zh: {
        ...serviceRegisterMessages.zh,
        ...sysDocumentMessages.zh,
        ...transactionLogMessages.zh,
        ...serviceImplMessages.zh,
        ...serviceManageMessages.zh,
        ...serviceProvideMessages.zh,
        ...serviceBindingMessages.zh,
        ...menuManageMessages.zh,
        ...reportCustomComponentFooterMessages.zh,
        ...reportCustomComponentMessages.zh,
        ...reportCustomComponentRelMessages.zh,
        ...reportCustomGroupMessages.zh,
        ...reportCustomMessages.zh,
        ...serviceMessages.zh,
        ...viewMenuGroupInfoMessages.zh,
        ...mappingDomainMessages.zh,
        ...mappingMessages.zh,
        ...menuCatalogMessages.zh,
        ...menuGroupCatalogMessages.zh,
        ...menuGroupMessages.zh,
        ...businessDatabusMessages.zh,
        ...businessTableHisMessages.zh,
        ...cacheManageMessages.zh,
        ...chooseMenuGroupMessages.zh,
        ...componentConditionMessages.zh,
        ...configMenuMessages.zh,
        ...demoMessages.zh,
        ...dictMessages.zh,
        ...initializeCommunityManageMessages.zh,
        ...jobMessages.zh,
        ...addMenuGroupMessages.zh,
        ...addMenuViewMessages.zh,
        ...addPrivilegeViewMessages.zh,
        ...appMessages.zh,
        ...attrSpecMessages.zh,
        ...attrValueMessages.zh,
        ...basePrivilegeMessages.zh,
        ...privilegeMessages.zh,
        ...addRouteMessages.zh,
        ...menuMessages.zh
    }
} 